var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarRightWSlide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1116,
    height: 627,
    viewBox: "0 0 1116 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 714,
    height: 402,
    rx: 33,
    fill: "#C5C5C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965 454.5C987.884 454.5 1009.83 445.413 1026.01 429.238C1042.19 413.063 1051.29 391.125 1051.29 368.25C1051.29 345.375 1042.19 323.437 1026.01 307.262C1009.83 291.087 987.884 282 965 282C942.116 282 920.168 291.087 903.987 307.262C887.805 323.437 878.714 345.375 878.714 368.25C878.714 391.125 887.805 413.063 903.987 429.238C920.168 445.413 942.116 454.5 965 454.5ZM934.193 486.844C867.794 486.844 814 540.615 814 606.987C814 618.038 822.966 627 834.021 627H1095.98C1107.03 627 1116 618.038 1116 606.987C1116 540.615 1062.21 486.844 995.807 486.844H934.193Z",
    fill: "#C5C5C5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 345,
    fill: "white",
    transform: "translate(814 282)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarRightWSlide);
export default __webpack_public_path__ + "static/media/avatar-right-w-slide.de95c40e311a71128f3775340410bcd7.svg";
export { ForwardRef as ReactComponent };